var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap lh-1" },
    [
      _c("div", { staticClass: "f22 fb pad20-t pad15-b" }, [
        _vm._v("查看评价")
      ]),
      _c("shopInfo", { attrs: { detail: _vm.detail, disabled: "" } }),
      _vm._l(_vm.detail.skuList, function(item) {
        return [
          item.evaluateSkuData
            ? _c("commentItem", {
                key: item.goodsId,
                staticClass: "mar15-t",
                attrs: { detail: item, orderId: _vm.orderId }
              })
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }